import { render, staticRenderFns } from "./AddressComponent.vue?vue&type=template&id=7b523447"
import script from "./AddressComponent.vue?vue&type=script&lang=js"
export * from "./AddressComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports